import api from "@/api";

export default {
    /**
     * Lấy tất cả các không gian làm việc
     * GET /api/workspaces
     */
    getAll(phongBanId) {
        let params = {};
    if (phongBanId) {
      params.phongBanId = phongBanId;
    }
        return api.get('/api/workspaces', { params: params });
    },

    /**
     * Tạo một không gian làm việc mới
     * POST /api/workspaces
     * @param {object} workspaceData Dữ liệu workspace mới (tieuDe, moTa, author)
     */
    create(workspaceData) {
        return api.post('/api/workspaces', workspaceData);
    },

    /**
     * Cập nhật một không gian làm việc
     * PUT /api/workspaces/{id}
     * @param {number} id ID của workspace
     * @param {object} workspaceData Dữ liệu cần cập nhật
     */
    update(id, workspaceData) {
        return api.put(`/api/workspaces/${id}`, workspaceData);
    },

    /**
     * Xóa một không gian làm việc
     * DELETE /api/workspaces/{id}
     * @param {number} id ID của workspace
     */
    deleteById(id) {
        return api.delete(`/api/workspaces/${id}`);
    },

    /**
     * Tạo một không gian làm việc mới từ một mẫu.
     * POST /workspaces/from/{templateId}
     * @param {number} templateId ID của workspace mẫu
     * @param {object} newWorkspaceData Dữ liệu cho workspace mới (tieuDe, moTa, author)
     */
    createFromTemplate(templateId, newWorkspaceData) {
        return api.post(`/api/workspaces/from/${templateId}`, newWorkspaceData)
    }
};